module.exports = __webpack_public_path__ + "img/jg3.63b23a36.png";